function ParseQP( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );
    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }
    return ( qpd );
}

function ItsInTheFuture( dateStr )
{
    var inTheFuture = false;
    var parts       = dateStr.split( "-" );

    if ( parts.length == 3 )
    {
        var monthNum = Number( parts[ 1 ] ) - 1;
        var dt       = new Date( parts[ 2 ], monthNum, parts[ 0 ], 0, 0, 0 );

        if ( dt.getTime( ) > new Date( ).getTime( ) )
        {
            inTheFuture = true;
        }
    }
    
    return ( inTheFuture )
}

function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function ShowFilterOnMobile( element )
{
    var filterType = element.dataset.filterType;
    var filterDrawers  = document.querySelectorAll( ".bridgman-facets-mobile-drawer" );
    var openDrawer = document.querySelector( ".bridgman-facets-mobile-drawer.facets-container-active" );
    var body    = document.querySelector( "body" );

    if( filterType == "close" && openDrawer )
    {
        openDrawer.classList.remove( "facets-container-active" );
        body.classList.remove( "drawer-active" );
    }
    else
    {
        filterDrawers.forEach( function( drawer )
        {
            if( drawer.dataset.filterType == filterType )
            {
                drawer.classList.add( "facets-container-active" );
                body.classList.add( "drawer-active" );
            }
        });
    }
    // var parent      = SearchParentsFor( element, "bridgeman-filter-child" );
    // var container   = parent.querySelector( ".bridgman-mobile-sort-container" );
    // var sortBylist   = parent.querySelector( ".bridgman--sort--container" );
    // var containers  = document.querySelectorAll( ".bridgman-mobile-sort-container" );
    // var isShowing   = false;

    // if( !container.classList.contains( "zero-opacity" ) )
    // {
    //     isShowing = true;
    // }

    // for( var i = 0; i < containers.length; i++ )
    // {
    //     var con = containers[ i ];
    //     con.classList.add( "zero-opacity" );
    //     if ( sortBylist ) 
    //     {  
    //         sortBylist.style.display = "none";
    //     }
    // }

    // if( !isShowing )
    // {
    //     container.classList.remove( "zero-opacity" );
    //     if ( sortBylist ) 
    //     {  
    //         sortBylist.style.display = "block";
    //     }
    // }
    // else
    // {
    //     container.classList.add( "zero-opacity" );
    //     if ( sortBylist ) 
    //     {  
    //         sortBylist.style.display = "none";
    //     }
    // }
}

function ShowSortOnMobile( element )
{
    var parent      = SearchParentsFor( element, "bridgeman-filter-child" );
    var container   = parent.querySelector( ".bridgman-mobile-sort-container" );
    var sortBylist   = parent.querySelector( ".bridgman--sort--container" );
    var containers  = document.querySelectorAll( ".bridgman-mobile-sort-container" );
    var isShowing   = false;

    if( !container.classList.contains( "zero-opacity" ) )
    {
        isShowing = true;
    }

    for( var i = 0; i < containers.length; i++ )
    {
        var con = containers[ i ];
        con.classList.add( "zero-opacity" );
        if ( sortBylist ) 
        {  
            sortBylist.style.display = "none";
        }
    }

    if( !isShowing )
    {
        container.classList.remove( "zero-opacity" );
        if ( sortBylist ) 
        {  
            sortBylist.style.display = "block";
        }
    }
    else
    {
        container.classList.add( "zero-opacity" );
        if ( sortBylist ) 
        {  
            sortBylist.style.display = "none";
        }
    }
}

function showSortBy( element )
{
    var parent = SearchParentsFor( element, "bridgeman-filter-parent" )
    ShowFilter( parent, element );
    var container   = parent.querySelector( ".bridgman-sort-container" );

    if( container.style.display != "none" )
    {
        container.style.display = "block";
    }
    else
    {
        container.style.display = "none";
    }
}

function revealDescription( element )
{
    var container = document.querySelector( ".desktop-description-container" );
    var description = document.querySelector( ".bridgman-collection-header-desc-container-inner" );
    var text = document.querySelector( ".bridgman-collection-header-desc-text-container" );
    var chevron   = element.querySelector( ".bridgman-filter-chevron" );
    var readmorelesstext   = element.querySelector( ".see-more" );

    if( container.classList.contains( "bridgman-collection-header-text-preview-mobile" ) )
    {
        description.classList.remove( "bridgman-collection-header-text-preview-mobile" );
        description.style.height = text.offsetHeight+"px";
        container.classList.remove( "bridgman-collection-header-text-preview-mobile" );
        chevron.classList.remove( "fa-chevron-down" );
        chevron.classList.add( "fa-chevron-up" );
        readmorelesstext.innerHTML = "Read Less";
    }
    else
    {
        description.classList.add( "bridgman-collection-header-text-preview-mobile" );
        description.style.height = 50+"px";
        container.classList.add( "bridgman-collection-header-text-preview-mobile" );
        chevron.classList.remove( "fa-chevron-up" );
        chevron.classList.add( "fa-chevron-down" );
        readmorelesstext.innerHTML = "Read More";
    }
}

function revealFeaturesInfo( element )
{
    var icon       = element.querySelector( ".bridgman-filter-chevron" );
    var allParents = document.querySelectorAll( ".features-text-container-mob" );
    var allIcons   = document.querySelectorAll( ".bridgman-filter-chevron" );
    var containerShowing;
    var target = document.querySelector( ".features-text-container-mob[data-index='" +  element.dataset.index + "']" );
    var targetChild = target.querySelector( ".product_features_support_text_container_mob" );
    var targetChildHeight = targetChild.offsetHeight;

    if( target.offsetHeight == 0 )
    {
        containerShowing = false;
    }
    else
    {
        containerShowing = true;
    }

    for( var i = 0; i < allParents.length; i++ )
    {
        var singleParent = allParents[ i ];
        if( singleParent.offsetHeight > 0 )
        {
            singleParent.style.height = "0px"; 
        }
        for( var j = 0; j < allIcons.length; j++ )
        {
            var singleIcon = allIcons[ i ];
            singleIcon.classList.remove( "fa-chevron-up" );
            singleIcon.classList.add( "fa-chevron-down" )
        }
    }

    window.setTimeout( function( ) {
        if( !containerShowing )
        {
            target.style.height = targetChildHeight + "px";
            target.style.transition = "height, 0.2s ease";
            icon.classList.remove( "fa-chevron-down" );
            icon.classList.add( "fa-chevron-up" )
        }
        else
        {
            target.style.height = "0px";
        }
    }, 200 );    
}
if($('.collection-selected-filters').length > 0){
    $('html, body').animate({
        scrollTop: $("#collectionFilters").offset().top - $('.header-section').height()
    }, 1000);
}

function HandleFilters()
{
    var path    = window.location.pathname;
    path        = path.split( "/" );
    
    for( var i = 0; i < path.length; i++ )
    {
        var tag = path[ i ];
        if( tag.includes( "group" ) )
        {
            if( tag.includes( "+" ) )
            {
                var tags = tag.split( "+" );
                for( var j = 0; j < tags.length; j++ )
                {
                    var splitTag = tags[ j ];
                    var filterGroup =  splitTag.replace( "group-", "" );
                    filterGroup     = filterGroup.split( "_" );
                    filterGroup     = filterGroup[ 0 ];
                    var filterURL;
        
                    if( filterGroup.includes( "-" ) )
                    {
                        filterURL = filterGroup.replaceAll( "-", " " );
                    }
                    else
                    {
                        filterURL = filterGroup;
                    }
        
                    var filterUL    = document.querySelector( "[ data-category='" + filterURL + "' ]" );
                    var anchors     = filterUL.querySelectorAll( "a" );
        
                    for( var k = 0; k < anchors.length; k++ )
                    {
                        var anchor = anchors[ k ];
        
                        if( anchor.href.includes( splitTag ) )
                        {
                            anchor.href = anchor.href.replace( "+" + splitTag, "" );
                        }
                    }

                }
            }
            else
            {
                var filterGroup =  tag.replace( "group-", "" );
                filterGroup     = filterGroup.split( "_" );
                filterGroup     = filterGroup[ 0 ];
                var filterURL;
    
                if( filterGroup.includes( "-" ) )
                {
                    filterURL = filterGroup.replaceAll( "-", " " );
                }
                else
                {
                    filterURL = filterGroup;
                }
    
                var filterUL    = document.querySelector( "[ data-category='" + filterURL + "' ]" );
                var anchors     = filterUL.querySelectorAll( "a" );
    
                for( var i = 0; i < anchors.length; i++ )
                {
                    var anchor = anchors[ i ];
    
                    if( anchor.href.includes( tag ) )
                    {
                        anchor.href = anchor.href.replace( "+" + tag, "" );
                    }
                }
            }
        }
    }
}

function OrderSeats()
{
    var ul 				= document.querySelector( ".advanced-filters[ data-category='number of seats' ]" );
    if( ul )
    {
        var links			= ul.querySelectorAll( "li" );
        var seatOrder		= ul.dataset.seatOrder;
        var originalLinks	= [];
        if( seatOrder )
        {
            for( var i = 0; i < links.length; i++ )
            {
                var link = links[ i ];
                originalLinks.push( link );
                link.parentNode.removeChild( link );
            }
            
            var seatOrder = seatOrder.split( "," );
            for( var i = 0; i < seatOrder.length; i++ )
            {
                var orderedString = seatOrder[ i ];
                for( var j = 0; j < originalLinks.length; j++ )
                {
                    var originalLink = originalLinks[ j ];
                    if( originalLink.querySelector( "a" ).innerText == orderedString )
                    {
                        ul.append( originalLink );
                        break;
                    }
                }
            }
        }
    }
}

function removeInStockFilter( )
{
    var queryParam     = "?in-stock=true";
    var currentURL     = window.location.href;
    var filterCheckbox = document.querySelector( ".filter-checkbox" );
    var filter         = false;
    var products       = document.querySelectorAll( ".product-card" );

    showProductsNotInStock( products );
    resetBrowserURL( currentURL, queryParam );
    handlePaginationLinkURLParam( queryParam, filter );
}

function SortByInStock()
{
    var queryParam     = "?in-stock=true";
    var currentURL     = window.location.href;
    if( currentURL.includes( queryParam ) )
    {
        window.location.href = window.location.href.replace( queryParam, "" );
    }
    else
    {
        window.location.href = window.location.origin + window.location.pathname + "?in-stock=true";
    }

    // The below could could be used if we want to sort by instock AND another value
    // if( currentURL.includes( queryParam ) )
    // {
    //     console.log(window.location.href, '<-- window.location.href');
    //     window.location.href = window.location.href.replace( queryParam, "" );
    // }
    // else
    // {
    //     console.log(window.location.href, '<-- window.location.href')
    //     if( window.location.href.includes( "?" ) )
    //     {
    //         window.location.href += "&in-stock=true";
    //     }
    //     else 
    //     {
    //         window.location.href += "?in-stock=true";
    //     }
    // }
}

function filterByInStock( )
{
    console.log( 'filterByInStock() called' )
    var queryParam     = "?in-stock=true";
    var currentURL     = window.location.href;
    var filterCheckbox = document.querySelector( ".filter-checkbox" );
    var filter         = true;
    var products       = document.querySelectorAll( ".product-card-template" );

    if( currentURL.includes( queryParam ) )
    {
        hideProductsNotInStock( products );
        handlePaginationLinkURLParam( queryParam, filter );
    }
    else
    {
        hideProductsNotInStock( products );
        updateBrowserURL( currentURL, queryParam );
        handlePaginationLinkURLParam( queryParam, filter );
    }
}

function updateBrowserURL( currentURL, queryParam )
{
    var newURL = currentURL + queryParam;
    var updatedURL = new URL( newURL );        
    window.history.pushState( {}, '', updatedURL );
}

function resetBrowserURL( currentURL, queryParam )
{
    if( currentURL.includes( queryParam ) )
    {
        // console.log('currentURL', currentURL)
        // console.log('qp', queryParam)

        var updatedURL = currentURL.replace( queryParam, "" );
        window.history.pushState( {}, '', updatedURL );
    }
}

function hideProductsNotInStock( products )
{    
    var stockCountContainer  = document.querySelector( ".collection-product-count-container" ).getElementsByTagName( "P" )[ 0 ];
    var filteredStockCount   = document.querySelector( ".filtered-item-count" );
    var inStockCount         = 0;

    for( var i = 0; i < products.length; i++ )
    {
        var product = products[ i ];
        {
            if( product.dataset.in_stock == "true" )
            {
                inStockCount++;
            }
            else
            {
                product.classList.add( "hidden" );
            }
        }
    }
    filteredStockCount.classList.remove( "hidden" )
    filteredStockCount.innerHTML = inStockCount + " items";

    stockCountContainer.classList.add( "hidden" );
}

function showProductsNotInStock( products )
{
    // var products             = document.querySelectorAll( ".product-card" );    
    var stockCountContainer  = document.querySelector( ".collection-product-count-container" ).getElementsByTagName( "P" )[ 0 ];
    var filteredStockCount   = document.querySelector( ".filtered-item-count" );
    var inStockCount         = 0;

    for( var i = 0; i < products.length; i++ )
    {
        var product = products[ i ];
        {
            if( product.dataset.in_stock == "false" )
            {
                product.classList.remove( "hidden" );
            }
        }
    }
    filteredStockCount.classList.add( "hidden" )
    stockCountContainer.classList.remove( "hidden" );
}

function getNumberOfInstockProducts( )
{
    if( !sessionStorage.getItem("items") )
    {
        var inStockContainer = document.querySelectorAll( ".product-card" )[ 0 ];
        if( inStockContainer )
        {
            var inStockValue = inStockContainer.dataset.instockAmount;
            var stockNumContainer = document.getElementById( "stock-num-container" );
            if( stockNumContainer )
            {
                stockNumContainer.innerText = inStockValue + " items";
            }
        }
    }
}

function handlePaginationLinkURLParam( queryParam, bool )
{
    var paginationLinks = document.querySelectorAll( ".paginate-btn" );

    if( bool )
    {
        for( var i = 0; i < paginationLinks.length; i++ )
        {
            var paginationContainer  = paginationLinks[ i ];
            if( paginationContainer.href && paginationContainer.href.includes( queryParam ) )
            {
            }  
            else
            {
                paginationContainer.href = paginationContainer.href + "&" + queryParam;  
            }
        }
    }
    else 
    {
        for( var i = 0; i < paginationLinks.length; i++ )
        {
            var paginationContainer  = paginationLinks[ i ];
            if( paginationContainer.href.includes( queryParam ) )
            {
                var newLink = paginationContainer.href.replace( queryParam, "" );
                paginationContainer.setAttribute( "href", newLink );
            }            
        }
    }
}

function CreateCustomPaginationButtons( totalPages )
{
    var paginationParent    = document.querySelector( ".pagination-custom" );
    var paginationButtons   = paginationParent.querySelectorAll( "li" );

    for( var i = 0; i < paginationButtons.length; i++ )
    {
        var button  = paginationButtons[ i ];
        if (button.querySelector( "a" ) )
        {
            var text    = Number( button.querySelector( "a" ).innerText );
            if( text > totalPages )
            {
                button.parentNode.removeChild( button );
            }
        }
    }
}

function ShowNumberOfItems( itemLength )
{
    // document.getElementById( "stock-num-container" ).innerText = itemLength + " items";
    document.querySelector( ".item-count" ).innerText = itemLength + " items";
}

// function handleCustomPagination( filteredProduct = null )
// {
//     var inStockProductArray = JSON.parse( sessionStorage.getItem("items") );
//     // var inStockProductArray = g_inStockItems;
//     var container = document.querySelector( ".bridgman-collection-products-parent" );
//     var productTemplate = document.querySelector( ".product-card-template" );
//     var paginateContainer = document.querySelector( ".paginate-container" );

//     var totalItems = inStockProductArray.length;
//     var limit = 50;
//     var currentPage;
//     var totalPages = Math.ceil( totalItems / limit );

//     CreateCustomPaginationButtons( totalPages );
//     ShowNumberOfItems( inStockProductArray.length );

//     var qp = ParseQP();
//     // console.log(qp, 'qp log');

//     if(  qp.page )
//     {
//         currentPage = qp.page
//     }
//     else
//     {
//         currentPage = 1
//     }

//     var nextPage = currentPage + 1;
//     var nextPageTag = document.querySelector( ".next-page" );
//     nextPageTag.href = window.location.href + "?page=" + nextPage;

//     $(container).empty();

//     for( var i = 0; i < inStockProductArray.length; i++ )
//     {
//         // if( currentPage == 1 && i < limit )
//         // console.log(i, ' log')
//         if( i >= ( (limit * currentPage) - limit ) && i < ( limit * currentPage ) )
//         {
//             var inStockProduct = inStockProductArray[ i ];
//             var clone = productTemplate.cloneNode(true);
//             clone.classList.remove( "hidden" );
//             var titleContainer = clone.querySelector( ".bridgman-product-card-title-container" );
//             var imageContainer = clone.querySelector( ".prod-card-img" );
//             var priceContainer = clone.querySelector( ".bridgman-product-card-price" );
    
//             titleContainer.innerText = inStockProduct.title;
//             imageContainer.src = inStockProduct.image
//             priceContainer.innerText = inStockProduct.price;

//             clone.querySelector( "a" ).setAttribute( "href", inStockProduct.url );
    
//             $(container).append( clone );
//         }
//     }
// }

function handleCustomPagination( filteredProducts = null )
{
    var inStockProductArray = filteredProducts || JSON.parse( sessionStorage.getItem("items") );
    // var inStockProductArray = g_inStockItems;
    var container = document.querySelector( ".bridgman-collection-products-parent" );
    var productTemplate = document.querySelector( ".product-card-template" );
    var paginateContainer = document.querySelector( ".paginate-container" );

    var totalItems = inStockProductArray.length;
    var limit = 50;
    var currentPage;
    var totalPages = Math.ceil( totalItems / limit );
    if ($('.pagination-custom').length > 0) {
        CreateCustomPaginationButtons( totalPages );
        }
    ShowNumberOfItems( inStockProductArray.length );

    var qp = ParseQP();

    if( qp.available )
    {
        var availableQp = "available=" + qp.available;
    
        handlePaginationLinkURLParam( availableQp, true );
    }


    if(  qp.page )
    {
        currentPage = qp.page
    }
    else
    {
        currentPage = 1
    }

    // var nextPage = currentPage + 1;
    // var nextPageTag = document.querySelector( ".next-page" );
    // nextPageTag.href = window.location.href + "?page=" + nextPage;

    $(container).empty();

    for( var i = 0; i < inStockProductArray.length; i++ )
    {
        // if( currentPage == 1 && i < limit )
        if( i >= ( (limit * currentPage) - limit ) && i < ( limit * currentPage ) )
        {
            var inStockProduct = inStockProductArray[ i ];
            var clone = productTemplate.cloneNode(true);
            clone.classList.remove( "hidden" );
            var titleContainer = clone.querySelector( ".title" );
            var imageContainer = clone.querySelector( ".prod-card-img" );
            var priceContainer = clone.querySelector( ".bridgman-product-card-price" );
    
            titleContainer.innerText = inStockProduct.title;
            imageContainer.src = inStockProduct.featured_image || inStockProduct.image
            priceContainer.innerText = inStockProduct.price;

            clone.querySelector( "a" ).setAttribute( "href", inStockProduct.url );
    
            $(container).append( clone );
        }
    }
}


function handleProductCardImageHover( )
{
    function hideImageOnMouseEnter() {
        if( $(this).data("has-hover-image") )
        {
            $(this).find('.prod-image').addClass( "hidden" );
            $(this).find('.hover-image').removeClass( "hidden" );
        }
    }
    
    function showImageOnMouseLeave() {
        if( $(this).data("has-hover-image") )
        {
            $(this).find('.prod-image').removeClass( "hidden" );
            $(this).find('.hover-image').addClass( "hidden" );
        }
    }
    
    $('.bridgman-product-card-image-container').hover( hideImageOnMouseEnter, showImageOnMouseLeave );
}

var monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];

var flattenedRestockDates;

function getMonthsFromRestockDates( restockDates )
{
    var collectedRestockDates = [];
    for( var i = 0; i < restockDates.length; i++ )
    {
        var restockDate = restockDates[ i ]
        var numericMonth = restockDate.split( "/" )[ 1 ];
        var month = monthNames[ numericMonth - 1 ];
        if( !collectedRestockDates.includes( month ) )
        {
            collectedRestockDates.push( month );
        }
    }

    return collectedRestockDates;
}

function addMonthToURL( e )
{
    var available = e.target.dataset.available_in

    var newURL = window.location.origin + window.location.pathname + "?available=" + available
    var updatedURL = new URL( newURL );        
    window.history.pushState( {}, '', updatedURL );

    getAvailableProductsForThatMonth( g_productCache );
}

function constructStockAvailabilityDropDown( preorderDates )
{
    
    var filterContainer = document.getElementById( "availabilityContainer" );
    if( filterContainer )
    {
        var filterContainerInner = filterContainer.getElementsByTagName( "div" )[ 0 ];
        var filterUlThisYear = document.createElement( "ul" );
        var filterUlNextYear = document.createElement( "ul" );
    
        filterUlThisYear.setAttribute( "aria-label", "Available this year" );
        filterUlNextYear.setAttribute( "aria-label", "Available next year" );
    
        var monthsAlreadyUsed = [];
    
        for( var i = 0; i < monthNames.length; i++ )
        {
            var monthName = monthNames [ i ];
            for( var j = 0; j < preorderDates.length; j++ )
            {
                var preorderDate = preorderDates[ j ];
                if( preorderDate && preorderDate.month == monthName )
                {
                    if( !monthsAlreadyUsed.includes( preorderDate.month ) )
                    {
                        
                        var li = document.createElement( "li" );
                        li.classList.add( "advanced-filter" );
        
                        var span = document.createElement( "span" );
                        span.innerHTML = "Available in " + preorderDate.month; 
                        span.setAttribute( "data-available_in", ( preorderDate.month + "-" + preorderDate.year ) );
                        li.appendChild( span ); 
                        li.addEventListener( "click", addMonthToURL );
                        if( preorderDate.year == "2021" )
                        {
                            filterUlThisYear.appendChild( li );
                        }
                        else 
                        {
                            filterUlNextYear.appendChild( li );
                        }
                        monthsAlreadyUsed.push(preorderDate.month)
                    }
                }
            }
        }
    
        filterContainerInner.appendChild( filterUlThisYear )
        filterContainerInner.appendChild( filterUlNextYear )
    
        filterContainer.classList.remove( "hidden" );
    }
}

function getMonthAndYear( restockDates )
{
    var collectedRestockDates = [];
    for( var i = 0; i < restockDates.length; i++ )
    {
        var restockDate = restockDates[ i ]
        if (restockDate != "") {
            if (restockDate.includes("/")) {
                var numericMonth = restockDate.split( "/" )[ 1 ];
                var year = restockDate.split( "/" )[ 2 ];
                var month = monthNames[ numericMonth - 1 ];                
            }else{
                var numericMonth = restockDate.split( "-" )[ 1 ];
                var year = restockDate.split( "-" )[ 2 ];
                var month = monthNames[ numericMonth - 1 ];
            }
            if( !collectedRestockDates.includes( month ) )
            {
                var date = {
                    month: month,
                    year: year
                }
                collectedRestockDates.push( date );
            }
        }
    }

    return collectedRestockDates;
}

function generateStockAvailabilityFilter( preorderProducts )
{
    var restockDates = [];
    for( var i = 0; i < preorderProducts.length; i++ )
    {
        var preorderProduct = preorderProducts [ i ];
        restockDates.push( preorderProduct.restock_dates )
    }
    var flattenedRestockDates = restockDates.flat();
    
    var monthAndYears = getMonthAndYear( flattenedRestockDates );
    constructStockAvailabilityDropDown( monthAndYears )
}

function getAvailableProductsForThatMonth( products )
{
    
    var qp = ParseQP();
    var { available } = qp;
    $('.stock-availability-filters li').removeClass('active-filter');
    $('.stock-availability-filters li span[data-available_in="'+available+'"]').parent().addClass('active-filter');
    var qpMonth = available.split( "-" )[ 0 ];
    var year = available.split( "-" )[ 1 ];

    var filteredProducts = [];

    function getMonthIndex( month )
    {
        return month == qpMonth;
    }
    
    var monthIndex = monthNames.findIndex( getMonthIndex ) + 1;
    var monthAndYearString = monthIndex + "/" + year;
    var monthAndYearStringDashed = monthIndex + "-" + year;
    
    for( var i = 0; i < products.length; i++ )
    {
        var product = products[ i ];
        for( var j = 0; j < product.restock_dates.length; j++ )
        {
            if( (product.restock_dates[ j ].includes( monthAndYearString ) || product.restock_dates[ j ].includes( monthAndYearStringDashed )) && !filteredProducts.includes( product ) )
            {
                filteredProducts.push( product )
            }
        }
    }
    var stockCountContainer  = document.querySelector( ".collection-product-count-container" ).getElementsByTagName( "P" )[ 0 ];
    stockCountContainer.innerHTML = filteredProducts.length + " items";

    handleCustomPagination( filteredProducts );
}

function getAllPreOrderProducts( products )
{
    var preorderProducts = [];

    for( var i = 0; i < products.length; i++ )
    {
        var product = products[ i ];
        if( product.restock_dates && product.restock_dates.length )
        {   
            for( var j = 0; j < product.restock_dates.length; j++ )
            {
                var restockDate = product.restock_dates[ j ];
                if( ItsInTheFuture( restockDate ) )
                {
                    preorderProducts.push( product );
                }
            }
        }
    }

    return preorderProducts
}

var g_productCache;

function getAllProducts( cb )
{
    if( g_productCache )
    {
        cb( g_productCache )
    }
    else
    {
        if( !window.location.pathname.includes( "special-offers" ) )
        {
            $.ajax({
                type: 'GET', 
                url: 'https://bridgman.co.uk/collections/view-all-garden-furniture?view=json',
                }).done( function( data ) {
                var products = $.parseJSON(data);
                g_productCache = products;
    
                cb( g_productCache )
            
                }).fail( function( data ) 
                {
                    console.log(data, 'ERROR')
                })
        }          
    }
}

function initiateStockAvailabilityFilter( products )
{
    var preorderProducts = getAllPreOrderProducts( products )
  
    generateStockAvailabilityFilter( preorderProducts );
    
    var currentURL = window.location.href;
    if( currentURL.includes( "?available" ) || currentURL.includes( "&available" ) )
    {
        getAvailableProductsForThatMonth( products )
    }
}

function HandleBackToTopScroll( e )
{
    // var target = document.querySelector( ".bridgman-products-wrapper" );
    // // target.scrollIntoView( { "behavior" : "smooth", "block" : "start", "inline" : "start" } );
    // var collectionHeader = window.pageYOffset - document.querySelector( ".bridgman-collection-header" ).offsetHeight;
    // // var amount =  document.querySelector( '.bridgman-products-wrapper' ).scrollHeight - document.documentElement.scrollHeight;
    // // console.log( amount )
    // // document.body.scrollTop             = collectionHeader; // For Safari
    // // document.documentElement.scrollTop  = collectionHeader; // For Chrome, Firefox, IE and Opera
    // document.querySelector( "body" ).scrollBy( { top : collectionHeader, left: 0, behavior: "smooth" } );

    document.querySelector( ".bridgman-collection-heaer-row" ).scrollIntoView( { "block" : "center", "inline" : "center", "behavior" : "smooth" } )
}

function HandleBackToTopListener()
{
    var el = document.querySelector( ".bridgman-back-to-top" );
  	if( el )
    {
        el.addEventListener( "click", function( e )
        {
            HandleBackToTopScroll( e );
        } );      
    }
}

function HandleWindowScroll( e )
{
    var el                  = document.querySelector( ".bridgman-back-to-top" );
  	if( el )
    {
        var amount              = GetAmountToShowBackToTop();

        if( window.pageYOffset >= amount )
        {
            el.classList.remove( "hidden" );
        }
        else
        {
            el.classList.add( "hidden" );
        }
    }
}

function GetAmountToShowBackToTop()
{
    var amount              = 0;
    var collectionHeader    = document.querySelector( ".bridgman-collection-header" );
    var header              = document.getElementById( "shopify-section-header" );
    var promo               = document.getElementById( "shopify-section-bridgman-promo-bar" );

    if( collectionHeader )
    {
        amount = amount + collectionHeader.clientHeight;
    }

    if( header )
    {
        amount = amount + header.clientHeight;
    }

    if( promo )
    {
        amount = amount + promo.clientHeight;
    }

    return amount;
}

window.addEventListener( "load", function() 
{
    getAllProducts( initiateStockAvailabilityFilter );

    var currentURL = window.location.href;
    if( currentURL.includes( "?in-stock=true" ) )
    {
        filterByInStock();
    }
    if( window.innerWidth > 768 && document.querySelector( ".bridgman-collection-header" ) )
    {
        // document.querySelector( ".bridgman-collection-filters-wrapper" ).scrollIntoView( { block: "start", inline: "nearest", behavior: "smooth" } )
        // document.querySelector( ".bridgman-collection-header" ).scrollIntoView( true )
    }
    // HandleFilters();

    getNumberOfInstockProducts();
  
  	OrderSeats();

    handleProductCardImageHover();
} );

window.addEventListener( "DOMContentLoaded", function() 
{
    if( document.querySelector( ".template-collection" ) )
    {
        HandleBackToTopListener();   
    }
} );

if( document.querySelector( ".template-collection" ) )
{
    window.addEventListener( "scroll", HandleWindowScroll );
}
